import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { HttpClientJsonpModule, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppStateService } from './shared/services/app-state.service';
import { ColorPickerModule } from 'ngx-color-picker';
import { ToastrModule } from 'ngx-toastr';
import { FilePondModule } from 'ngx-filepond';
import { NgbCollapseModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxCleaveDirectiveModule } from 'ngx-cleave-directive';
import { FlatpickrModule } from 'angularx-flatpickr';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { TableModule } from 'ngx-easy-table';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import {MatTableModule} from '@angular/material/table';
import {MatTableDataSource} from '@angular/material/table';
import { NgApexchartsModule } from 'ng-apexcharts';
import { billReducer } from './store/bill/bill.reducer';
import { BillsEffects } from './store/bill/bill.effects';
import { authInterceptor, unauthInterceptor } from './shared/auth/auth.interceptor';
import { errorInterceptor } from './shared/error_handling/error_handling.interceptor';
import { billsDownloadReducer } from './store/bill/bills_download/bill_download.reducer';
import { loggedUserReducer } from './store/logged_user/logged_user.reducer';
import { billsUploadS3Reducer } from './store/bill/bill_upload_s3/bill_upload_s3.reducer';
import { billsViewReducer } from './store/bill/bills_view/bills_view.reducer';
import { billsGetCsvReducer } from './store/bill/bills_download_csv/bill_download_csv.reducer';
import { SettingsEffects } from './store/settings/settings.effects';
import { settingsReducer } from './store/settings/settings.reducer';
import { billExtractionReducer } from './store/bill/bills_extraction/bill_extraction.reducer';
import { UsersEffects } from './store/user/user.effects';
import { userReducer } from './store/user/user.reducer';
import { LoggedUserEffects } from './store/logged_user/logged_user.effects';
import { customersReducer } from './store/customers/customers.reducer';
import { CustomersEffects } from './store/customers/customers.effects';
import { billsGetExcelReducer } from './store/bill/bills_download_excel/bill_download_excel.reducer';
import { presignedUrlReducer } from './store/bill/presigned_url/presigned_url.reducer';
import { billUploadBackendReducer } from './store/bill/bill_upload_backend/bill_upload_backend.reducer';
import { userInfoReducer } from './store/user/user_info/user_info.reducer';
import { providerReducer } from './store/load_curves/provider/provider.reducer';
import { LoadCurvesEffects } from './store/load_curves/load_curves.effects';
import { providersCredentialsReducer } from './store/load_curves/provider_credentials/provider_credentials.reducer';
import { counterReducer } from './store/load_curves/counter/counter.reducer';
import { loadCurvesCustomersReducer } from './store/load_curves/customer/customers.reducer';
import { identityCardReducer } from './store/documents/identity_card/identity_card.reducer';
import { IdentityCardEffects } from './store/documents/identity_card/identity_card.effects';
import { ciPresignedUrlReducer } from './store/documents/identity_card/presigned_url/ci_presigned_url.reducer';
import { ciUploadS3Reducer } from './store/documents/identity_card/upload_s3/ci_upload_s3.reducer';
import { ciUploadBackendReducer } from './store/documents/identity_card/upload_backend/ci_upload_backend.reducer';
import { ciExtractionReducer } from './store/documents/identity_card/extraction/ci_extraction.reducer';
import { ciDownloadReducer } from './store/documents/identity_card/download/ci_download.reducer';
import { ciDeleteDocumentReducer } from './store/documents/identity_card/delete_document/ci_delete_document.reducer';
import { ciDeleteExtractionReducer } from './store/documents/identity_card/delete_extraction/ci_delete_extraction.reducer';
import { ciCsvReducer } from './store/documents/identity_card/csv/ci_csv.reducer';
import { ciExcelReducer } from './store/documents/identity_card/excel/ci_excel.reducer';
import { driverLicenseReducer } from './store/documents/driver_license/driver_license.reducer';
import { DriverLicenseEffects } from './store/documents/driver_license/driver_license.effects';
import { dlPresignedUrlReducer } from './store/documents/driver_license/presigned_url/dl_presigned_url.reducer';
import { dlUploadS3Reducer } from './store/documents/driver_license/upload_s3/dl_upload_s3.reducer';
import { dlUploadBackendReducer } from './store/documents/driver_license/upload_backend/dl_upload_backend.reducer';
import { dlExtractionReducer } from './store/documents/driver_license/extraction/dl_extraction.reducer';
import { dlDownloadReducer } from './store/documents/driver_license/download/dl_download.reducer';
import { dlDeleteDocumentReducer } from './store/documents/driver_license/delete_document/dl_delete_document.reducer';
import { dlDeleteExtractionReducer } from './store/documents/driver_license/delete_extraction/dl_delete_extraction.reducer';
import { dlCsvReducer } from './store/documents/driver_license/csv/dl_csv.reducer';
import { dlExcelReducer } from './store/documents/driver_license/excel/dl_excel.reducer';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideAnimationsAsync(),
    importProvidersFrom(AppStateService,ColorPickerModule, ToastrModule.forRoot({ positionClass: 'top' }),FullCalendarModule,FilePondModule,NgbNavModule,AngularEditorModule,NgbCollapseModule,NgxCleaveDirectiveModule,TableModule,NgxSliderModule,FlatpickrModule,MatTableModule,MatTableDataSource,NgApexchartsModule,ColorPickerModule,HttpClientModule,HttpClientJsonpModule),
    provideHttpClient(withInterceptors([errorInterceptor, unauthInterceptor, authInterceptor])),
    provideStore({
      bills: billReducer,
      billsDownloadLinks: billsDownloadReducer,
      billsCsv: billsGetCsvReducer,
      billsExcel: billsGetExcelReducer,
      billsUploadS3: billsUploadS3Reducer,
      billsUploadBackend: billUploadBackendReducer,
      loggedUser: loggedUserReducer,
      billsView: billsViewReducer,
      settings: settingsReducer,
      billExtractionErrors: billExtractionReducer,
      users: userReducer,
      userInfo: userInfoReducer,
      customers: customersReducer,
      presignedUrl: presignedUrlReducer,
      providers: providerReducer,
      providersCredentials: providersCredentialsReducer,
      counters: counterReducer,
      loadCurvesCustomers: loadCurvesCustomersReducer,
      identityCard: identityCardReducer,
      ciPresignedUrl: ciPresignedUrlReducer,
      ciUploadS3: ciUploadS3Reducer,
      ciUploadBackend: ciUploadBackendReducer,
      ciExtraction: ciExtractionReducer,
      ciDownload: ciDownloadReducer,
      ciDeleteDocument: ciDeleteDocumentReducer,
      ciDeleteExtraction: ciDeleteExtractionReducer,
      ciCsv: ciCsvReducer,
      ciExcel: ciExcelReducer,
      driverLicense: driverLicenseReducer,
      dlPresignedUrl: dlPresignedUrlReducer,
      dlUploadS3: dlUploadS3Reducer,
      dlUploadBackend: dlUploadBackendReducer,
      dlExtraction: dlExtractionReducer,
      dlDownload: dlDownloadReducer,
      dlDeleteDocument: dlDeleteDocumentReducer,
      dlDeleteExtraction: dlDeleteExtractionReducer,
      dlCsv: dlCsvReducer,
      dlExcel: dlExcelReducer,
    }),
    provideEffects(
      BillsEffects,
      SettingsEffects,
      UsersEffects,
      LoggedUserEffects,
      CustomersEffects,
      LoadCurvesEffects,
      IdentityCardEffects,
      DriverLicenseEffects
    ),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() })
  ]
};
